import type { ComponentProps } from 'react';
import React from 'react';

import FormButton from '@components/form/form-button';
import { useVismaConfiguration } from '@services/visitor-management';

interface ButtonNextProps extends ComponentProps<typeof FormButton> {
  title?: string;
  isLoading?: boolean;
}

function ButtonNext({ title, disabled, isLoading, ...rest }: ButtonNextProps) {
  const { configuration } = useVismaConfiguration();
  const label = title ?? configuration?.generalInformation?.button_next;

  return (
    <FormButton type="primary" disabled={disabled || isLoading} {...rest}>
      {label}
    </FormButton>
  );
}

export default ButtonNext;
